module.exports = __webpack_public_path__ + "img/val-company-hover.c8c3eb66.png";